import { Stack, Text, ThemeIcon } from "@mantine/core";
import { IconInbox } from "@tabler/icons-react";
import type { ReactNode } from "react";

/** Centered "nothing here" block with an optional action. */
export function EmptyState({
  title = "Nothing here yet",
  hint,
  action,
}: {
  title?: string;
  hint?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Stack align="center" gap="xs" py="xl" data-testid="empty-state">
      <ThemeIcon variant="light" size={48} radius="xl" color="gray">
        <IconInbox size={26} />
      </ThemeIcon>
      <Text fw={600}>{title}</Text>
      {hint && (
        <Text c="dimmed" size="sm" ta="center">
          {hint}
        </Text>
      )}
      {action}
    </Stack>
  );
}
